import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { setJournalPrivacy } from 'actions/myself';

import getCanChangeFaceForFree from 'selectors/myself/getCanChangeFaceForFree';

import Modal from 'components/Modal';
import PurchaseFace from 'components/Fate/components/PurchaseModal/PurchaseFace';

import ProfileComponent from './ProfileComponent';
import myselfProfilePropTypes from './prop-types';

const FACE_CHANGE_FATE_ITEM_ID = 13;

class ProfileContainer extends Component {
  state = {
    // We'll optimistically update this, so that the delay isn't so visible
    isViewCameosModalOpen: false,
    journalIsPrivate: false,
  }

  componentDidMount = () => {
    const { journalIsPrivate } = this.props;
    this.setState({ journalIsPrivate });
  }

  componentDidUpdate = (prevProps) => {
    const { journalIsPrivate } = this.props;
    const { journalIsPrivate: stateJournalIsPrivate } = this.state;
    if (prevProps.journalIsPrivate === journalIsPrivate) {
      return;
    }
    if (stateJournalIsPrivate === journalIsPrivate) {
      return;
    }
    this.setState({ journalIsPrivate });
  }

  /**
 * Select Quality
 * @return {undefined}
 */
  changeJournalPrivacy = (event) => {
    const { dispatch } = this.props;
    const shouldBeChecked = event.target.checked;
    this.setState({ journalIsPrivate: shouldBeChecked });
    dispatch(setJournalPrivacy(event.target.checked));
  }

  viewCameos = () => {
    this.setState({ isViewCameosModalOpen: true });
  }

  handleRequestClose = () => {
    this.setState({ isViewCameosModalOpen: false });
  }

  /**
   * Render
   * @return {JSX}
   */
  render() {
    const {
      avatarImage,
      canChangeFaceForFree,
      fate,
      mantelpieceItemId,
      scrapbookStatusId,
    } = this.props;

    const { isViewCameosModalOpen } = this.state;

    const { journalIsPrivate } = this.state;

    return (
      <Fragment>
        <ProfileComponent
          avatarImage={avatarImage}
          canChangeFaceForFree={canChangeFaceForFree}
          journalIsPrivate={journalIsPrivate}
          changeJournalPrivacy={this.changeJournalPrivacy}
          mantelpieceItemId={mantelpieceItemId}
          scrapbookStatusId={scrapbookStatusId}
          viewCameos={this.viewCameos}
          onDisplayQualityClick={this.showDialog}
        />
        <Modal
          isOpen={isViewCameosModalOpen}
          onRequestClose={this.handleRequestClose}
        >
          <PurchaseFace
            data={fate.data.fateCards.find(card => card.id === FACE_CHANGE_FATE_ITEM_ID)}
            isFree={canChangeFaceForFree}
            onRequestClose={this.handleRequestClose}
          />
        </Modal>
      </Fragment>
    );
  }
}

ProfileContainer.displayName = 'ProfileContainer';

ProfileContainer.propTypes = {
  ...myselfProfilePropTypes,
};

const mapStateToProps = ({
  fate,
  myself: {
    qualities,
    qualityPickerType,
    character: {
      avatarImage,
      journalIsPrivate,
      mantelpieceItemId,
      name,
      scrapbookStatusId,
    },
  },
}) => ({
  avatarImage,
  canChangeFaceForFree: getCanChangeFaceForFree({ myself: { qualities } }),
  fate,
  journalIsPrivate,
  mantelpieceItemId,
  name,
  qualityPickerType,
  scrapbookStatusId,
});

export default withRouter(connect(mapStateToProps)(ProfileContainer));
